import { createSelector } from '../../dependencies';

export const supplierSelector = (state, id) => state.entities.suppliers.byId[id];

export const supplierNameSelector = createSelector(
    [supplierSelector],
    ({ name }) => name,
);
